module.exports = __webpack_public_path__ + "img/ru.320b9fd3.svg";